// extracted by mini-css-extract-plugin
module.exports = {"sales_start_label--hoverable":"_0fce717cdb--sales_start_label--hoverable--x9Ot0","sales_start_label_icon":"_0fce717cdb--sales_start_label_icon--m8Wry"};